module.exports = __webpack_public_path__ + "b2db3494078fdb92f8844b315f81aac1.pdf";